import { render, staticRenderFns } from "./VideoVerificationDetails.vue?vue&type=template&id=3c85a29f&scoped=true"
import script from "./VideoVerificationDetails.vue?vue&type=script&lang=js"
export * from "./VideoVerificationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85a29f",
  null
  
)

export default component.exports